import React, {Component} from 'react';
import {AppBar, Box, Grid, Tab, Tabs, Toolbar} from "@material-ui/core";
import {MainContext} from "contexts/main.context";
import {Route, Switch} from 'react-router-dom';
import SubHeader from "components/helpers/subHeader/subHeader";
import {Pendientes} from "./pendientes";
import {Recibidos} from "./recibidos";
import Badge from "@material-ui/core/Badge";

const basePath = '/ventas/recepciones';

export class Cobranzas extends Component {
    state = {
        tabActive: 'pendientes',
        pendientes: 0,
        fechaDialogOpened: false,
        itemEditing: null
    };

    componentDidMount() {
        if (this.props.location.pathname.indexOf('recibidos') > -1)
            this.setState({tabActive: 'recibidos'});
    }

    changeTab = (event, value) => {
        this.setState({tabActive: value});
        this.props.history.push(`${this.props.match.url}/${value}`);
    };

    setPendientes = pendientes => this.setState({pendientes: pendientes})

    render() {
        const {tabActive, pendientes} = this.state;
        return (
            <div>
                <SubHeader
                    title={'Recepciones'}
                    subtitle={'Confirmar recepción de items'}
                />
                <AppBar position="relative" elevation={0}>
                    <Toolbar variant="dense" color='primary'>
                        <Grid container justify="space-between" alignItems="center">
                            <Grid item md={4}>
                                <Tabs
                                    value={tabActive}
                                    onChange={this.changeTab}
                                    indicatorColor="secondary"
                                    textColor="inherit"
                                >
                                    <Tab label={<Badge color="secondary" className='pr-3' badgeContent={pendientes}>Pendientes</Badge>} value='pendientes'/>
                                    <Tab label="Confirmados" value='recibidos'/>
                                </Tabs>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <Box className='container-xl mt-3 mb-3'>
                    <Switch>
                        <Route path={`${basePath}/recibidos`} component={Recibidos}/>
                        <Route path={`${basePath}`} render={() => <Pendientes setPendientes={this.setPendientes}/>}/>
                    </Switch>
                </Box>
            </div>
        )
    }
}

Cobranzas.contextType = MainContext;
